import React from 'react'
import { BodyText, HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { GroupItem } from '../../../../typings'
import { CloseGroupFooter } from './components/CloseGroupFooter'
import * as styles from './index.css'

interface CloseGroupProps {
  groupItem: GroupItem
  onSubmit: (groupId: string) => void
}

export const CloseGroup = ({ groupItem, onSubmit }: CloseGroupProps) => {
  return (
    <div className={styles.closeGroup} data-testid="closeGroupSection">
      <HeadingText size="sm">
        <Message id="update.closeGroup.title" />
      </HeadingText>
      <BodyText>
        <Message id="update.closeGroup.description" />
      </BodyText>
      <CloseGroupFooter groupItem={groupItem} onCloseGroup={onSubmit} />
    </div>
  )
}
